<template>
    <div class="body_main">
        <div class="body_bd">
            <!-- 搜索-->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
                <el-form-item label="姓名">
                    <el-input
                        v-model="queryParams.name"
                        placeholder="请输入患者姓名"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="身份证">
                    <el-input
                        v-model="queryParams.identity"
                        placeholder="请输入患者身份证"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input
                        v-model="queryParams.phoneNumber"
                        placeholder="请输入患者手机号码"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="登记日期">
                    <el-date-picker
                        v-model="dateTime"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="chooseDateTime($event)"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" @click="getPatientListInfo">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格-->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="100"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column
                        label="基本信息">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{
                                            scope.row.name
                                        }} </span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }} {{
                                            scope.row.age
                                        }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="手机号码">
                        <template #default="scope">
                            <span>{{ scope.row.phoneNumber === null ? '---' : scope.row.phoneNumber }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="身份证号码">
                        <template #default="scope">
                            <span>{{ scope.row.identity === null ? '---' : scope.row.identity }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="联系地址">
                        <template #default="scope">
                            <span>{{ scope.row.province === null ? '---' : scope.row.province }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="过敏史">
                        <template #default="scope">
                            <div class="span_con">
                                {{ scope.row.operationHistory === null ? '---' : scope.row.operationHistory }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="登记日期">
                    </el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注">
                        <template #default="scope">
                            <div class="span_con">{{ scope.row.remark === null ? '---' : scope.row.remark }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="160">
                        <template #default="scope">
                            <!--                            <el-tooltip content="接诊" placement="bottom">-->
                            <!--                                <el-button type="primary" icon="Stamp" circle v-on:click="openGoods(scope.$index, tableData)"></el-button>-->
                            <!--                            </el-tooltip>-->
                            <el-tooltip content="详情" placement="bottom">
                                <el-button type="success" icon="MoreFilled" circle
                                           v-on:click="openPatientDetail(scope.row.dppId)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>
    </div>

    <!--患者病例详情-->
    <el-drawer :with-header="false" v-model="paetientDialogVisible" :direction="direction" destroy-on-close size="72%"
               style="background: #f5f7fa">
        <div class="drawer_con">
            <div class="drawer_title">
                <span>患者病例详情</span>
                <el-icon class="drawer_icon" @click="paetientDialogVisible = false">
                    <close-bold/>
                </el-icon>
            </div>
            <div class="patient_info_bd">
                <div class="drawer_info_body">
                    <div class="drawer_info_bd">
                        <el-image class="drawer_info_img" :src="patientInfo.avatarImg"></el-image>
                        <div class="drawer_info_body">
                            <div class="drawer_info_line">
                                <span class="name_font">{{ patientInfo.name }}</span>
                                <el-tooltip content="点击编辑病例信息" placement="right">
                                    <el-icon class="name_icon mrl20" @click="editBaseInfo()">
                                        <edit/>
                                    </el-icon>
                                </el-tooltip>
                            </div>
                            <div class="drawer_info_line">
                                <span class="mrr20"><span class="font_gray">性别：</span>{{
                                        patientInfo.sex === '0' ? '男' : patientInfo.sex === '1' ? '女' : '未知'
                                    }}</span>
                                <span class="mrr20"><span class="font_gray">年龄：</span>{{
                                        patientInfo.age === null ? '--' : patientInfo.age
                                    }}岁</span>
                                <span class="mrr20"><span class="font_gray">地址：</span>{{
                                        patientInfo.province === null ? '无' : patientInfo.province
                                    }}</span>
                                <span class="mrr20"><span class="font_gray">联系电话：</span>{{
                                        patientInfo.phoneNumber === null ? '无' : patientInfo.phoneNumber
                                    }}</span>
                                <span class="mrr20"><span class="font_gray">身份证号码：</span>{{
                                        patientInfo.identity === null ? '无' : patientInfo.identity
                                    }}</span>
                                <span class="mrr20"><span
                                    class="font_gray">身高体重：</span>{{ patientInfo.height === null ? '--' : patientInfo.height }} cm  /  {{ patientInfo.weight === null ? '--' : patientInfo.weight }} kg</span>
                            </div>
                            <div class="drawer_info_line">
                                <span class="mrr20"><span
                                    class="font_gray">过敏历史：</span>{{ patientInfo.operationHistory === null ? '无' : patientInfo.operationHistory }}</span>
                            </div>
                            <div class="drawer_info_line">
                                <span class="mrr20"><span
                                    class="font_gray">既往病史：</span>{{ patientInfo.medicalHistory === null ? '无' : patientInfo.medicalHistory }}</span>
                            </div>
                            <div class="drawer_info_img_con">
                                <div class="drawer_info_img_label font_gray">实体医疗机构病历：</div>
                                <div class="info_input_more flex_left_warp" v-if="casePicArray.length > 0">
                                    <el-image class="med_img_li" :src="item" v-for="(item,index) in casePicArray"
                                              :key="index" :preview-src-list="casePicArray"></el-image>
                                </div>
                                <div class="info_input_more flex_center" v-if="casePicArray.length <= 0">
                                    <span class="font-14 text-gray">暂无实体医疗机构病历图片</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="patient_order_table">
                <!-- 搜索-->
                <el-form class="search_con" :model="queryRecordParams" ref="queryForm" :inline="true"
                         label-width="100px">
                    <el-form-item label="">
                        <el-input
                            v-model="queryRecordParams.chiefComplaint"
                            placeholder="搜索关键字（主诉/诊断）"
                            clearable
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button class="mrl20" type="primary" icon="Search" @click="getMedicalRecordList">搜索</el-button>
                    </el-form-item>
                </el-form>

                <!-- 表格-->
                <div class="table_bd">
                    <el-table
                        ref="multipleOrderTable"
                        v-loading="recordTableLoading"
                        :data="recordlist"
                        :height="recordTableHeight"
                        style="width: 100%">
                        <template #empty>
                            <el-empty :image-size="120"></el-empty>
                        </template>
                        <el-table-column
                            width="180px"
                            label="就诊日期">
                            <template #default="scope">
                                <div class="span_con">
                                    {{scope.row.createTime === null ? '---' : scope.row.createTime}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="开方来源">
                            <template #default="scope">
                                <div class="span_con">
                                    {{ scope.row.orderSource === 'clinic' || scope.row.orderSource === 'clinicRepeat' ? '门诊开方' : scope.row.orderSource === 'patient' || scope.row.orderSource === 'patientRepeat' ? '患者自拍开方' : '医生开方' }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="药方剂型">
                            <template #default="scope">
                                <div class="span_con">
                                    {{ scope.row.billingType === '1' ? '饮片' : scope.row.billingType === '2' ? '膏方' : scope.row.billingType === '3' ? '水丸' : '颗粒' }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="220px"
                            label="药方号">
                            <template #default="scope">
                                <div class="span_con" :title="scope.row.serialNo === null ? '---' : scope.row.serialNo">
                                   {{scope.row.serialNo === null ? '---' : scope.row.serialNo}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="160px"
                            label="主诉">
                            <template #default="scope">
                                <div class="span_con" :title="scope.row.mainSuit === null ? '---' : scope.row.mainSuit">
                                    {{scope.row.mainSuit === null ? '---' : scope.row.mainSuit}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="240px"
                            label="诊断">
                            <template #default="scope">
                                <div class="span_con" :title="scope.row.clinicalDiagnosis === null ? '---' : scope.row.clinicalDiagnosis">
                                    {{ scope.row.clinicalDiagnosis === null ? '---' : scope.row.clinicalDiagnosis}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="300px"
                            label="药方详情">
                            <template #default="scope">
                                <div class="span_con">
                                    每剂{{ scope.row.orderMedicineList.length }} 味药，共{{ scope.row.viceNum }}剂，总重{{ getOrderWeightByNewGCount(scope.row.orderMedicineList) }}g
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="400px"
                            label="药材清单">
                            <template #default="scope">
                                <div class="span_con" :title="scope.row.medicineName === null ? '---' : scope.row.medicineName">
                                    {{ scope.row.medicineName === null ? '---' : scope.row.medicineName}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="配送方式">
                            <template #default="scope">
                                <div class="span_con">
                                    {{ scope.row.deliverWay === '1' ? '门诊自取' : '物流配送'}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="100px"
                            label="费用合计">
                            <template #default="scope">
                                <div class="span_con">
                                    ￥{{ scope.row.orderPrice }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="80px"
                            label="是否初诊">
                            <template #default="scope">
                                {{ scope.row.isFirstVisit === '0' ? '初诊' : '复诊' }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="remark"
                            width="180px"
                            label="备注">
                            <template #default="scope">
                                <div class="span_con" :title="scope.row.remark === null ? '---' : scope.row.remark">
                                    {{ scope.row.remark === null ? '---' : scope.row.remark }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作"
                            width="150px">
                            <template #default="scope">
                                <el-button type="primary" size="small" v-on:click="setMedicinalRecord(scope.row)">去开方</el-button>
                                <el-button type="success" size="small" v-on:click="openOrderDetail(scope.row.orderId)">药方</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 分页-->
                <div class="table_pagination">
                    <el-pagination
                        background
                        @size-change="handleRecordSizeChange"
                        @current-change="handleRecordCurrentChange"
                        :current-page="currentPageRecord"
                        :page-size="pageNumsRecord"
                        layout="prev, pager, next, total, sizes"
                        :total="totalCountRecord">
                    </el-pagination>
                </div>
            </div>
        </div>
    </el-drawer>

    <!--编辑患者病例基本信息-->
    <el-dialog
        title="编辑基本信息"
        v-model="editBaseInfoVisible"
        width="40%">
        <div class="dislog_con">
            <el-form ref="form" label-width="130px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="姓名">
                            <el-input placeholder="请输入患者姓名" v-model="patientInfoFrom.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别">
                            <el-select placeholder="请选择性别" style="width: 100%" v-model="patientInfoFrom.sex">
                                <el-option label="男" value="0"></el-option>
                                <el-option label="女" value="1"></el-option>
                                <el-option label="未知" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="联系电话">
                            <el-input placeholder="请输入患者联系电话" v-model="patientInfoFrom.phoneNumber"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="年龄">
                            <el-input type="number" placeholder="年龄" v-model="patientInfoFrom.age">
                                <template #append>岁</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="身份证号码">
                            <el-input placeholder="请输入患者身份证号码" v-model="patientInfoFrom.identity"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="身高">
                            <el-input type="number" placeholder="身高（选填）" v-model="patientInfoFrom.height">
                                <template #append>cm</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="所在地市">
                            <el-input placeholder="请输入患者所在地市（选填）" v-model="patientInfoFrom.province"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="体重">
                            <el-input type="number" placeholder="体重（选填）" v-model="patientInfoFrom.weight">
                                <template #append>kg</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="过敏历史">
                    <el-input placeholder="请填写患者过敏历史" type="textarea"
                              v-model="patientInfoFrom.operationHistory"></el-input>
                </el-form-item>
                <el-form-item label="既往病史">
                    <el-input placeholder="请填写患者既往病史" type="textarea"
                              v-model="patientInfoFrom.medicalHistory"></el-input>
                </el-form-item>
                <el-form-item label="实体医疗机构病历">
                    <el-upload
                        method="post"
                        :action="uploadFileURL"
                        :headers="uploadHeaders"
                        list-type="picture-card"
                        :show-file-list="true"
                        :file-list="confileLists"
                        :limit="10"
                        :before-upload="beforeAvatarUpload"
                        :on-success="handleAvatarSuccess"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                    >
                        <el-icon><Plus/></el-icon>
                    </el-upload>
                    <el-dialog v-model="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog>
                </el-form-item>

            </el-form>
        </div>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="cancelEditBaseInfo()">取 消</el-button>
                    <el-button type="primary" @click="saveEditBaseInfo()">保 存</el-button>
                </span>
        </template>

    </el-dialog>

    <!--订单详情-->
    <el-drawer :with-header="false" v-model="orderDetailDialogVisible" :direction="direction" destroy-on-close
               size="36%" :modal="true" @close="closeOrderDetail()"
               style="background: #f5f7fa">
        <div class="drawer_con">
            <div class="drawer_title">
                <span>订单详情</span>
                <el-icon class="drawer_icon" @click="orderDetailDialogVisible = false">
                    <close-bold/>
                </el-icon>
            </div>
            <Orderdetail :orderId="orderId"></Orderdetail>
        </div>
    </el-drawer>

</template>

<script>
import patient from "@/assets/scripts/patient/index";

export default patient;
</script>

<style scoped>
@import "@/assets/styles/style.scss";
</style>
